// GET /api/instruments/all возвращает инструменты, сгруппированные по категориям:
// [{ id, name, instruments: [{ id, name }, ...] }, ...].
// Для выбора нужен плоский список.
export const flattenInstruments = (groups = []) =>
	groups.flatMap((group) =>
		(group?.instruments || []).map((instrument) => ({
			...instrument,
			groupName: group?.name,
		}))
	)
